import 'react-image-crop/dist/ReactCrop.css';

import { useEffect, useState } from 'react';
import type { Crop } from 'react-image-crop';
import ReactCrop from 'react-image-crop';

import styled from '@emotion/styled';
import { WIDGET_Z_INDEX } from '@hotjar/webapp/features/Heatmaps/ContinuousCaptureReport/ReportWidgets/constants';
import { tokens } from '@hotjar/hotsauce';
import { useTranslation } from 'react-i18next';

// A 1px x 1px transparent png encoded as base64
const imageSrc =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

const HighlightAreaSelectorContainer = styled.div`
  position: relative;
  /* This is so the selection area appears behind the clicks recorded and heatmap help widget */
  z-index: ${WIDGET_Z_INDEX - 10};

  .ReactCrop__crop-selection {
    border: 2px dashed ${tokens.color.white};
  }

  .ReactCrop__drag-handle::after {
    background-color: ${tokens.color.white};
    border-radius: 50%;
  }
`;

interface HighlightAreaSelectorProps {
  width: number;
  height: number;
  onChange: (crop: Crop, percentageCrop: Crop) => void;
  crop: Crop;
}

export const HighlightAreaSelector = ({
  width,
  height,
  onChange,
  crop,
}: HighlightAreaSelectorProps): JSX.Element | null => {
  const { t } = useTranslation();
  const [internalCrop, setInternalCrop] = useState<Crop>({});
  useEffect(() => {
    if (!crop) {
      return;
    }

    setInternalCrop(crop);
  }, [crop]);

  return (
    <HighlightAreaSelectorContainer
      aria-label={t('highlights:heatmaps.highlightAreaSelectorContainer')}
    >
      <ReactCrop
        src={imageSrc}
        imageStyle={{
          width,
          height,
        }}
        crop={internalCrop}
        onChange={(newCrop: Crop) => setInternalCrop(newCrop)}
        onComplete={(data: Crop, percentageCrop: Crop) => {
          onChange(data, percentageCrop);
        }}
      />
    </HighlightAreaSelectorContainer>
  );
};
